module.exports = __webpack_public_path__ + "static/don48-3db66fe0e037df7f4a27a238d637f16b.jpg";